import { render, staticRenderFns } from "./AddGoodsGroup.vue?vue&type=template&id=1535d698&scoped=true"
import script from "./AddGoodsGroup.vue?vue&type=script&lang=js"
export * from "./AddGoodsGroup.vue?vue&type=script&lang=js"
import style0 from "./AddGoodsGroup.vue?vue&type=style&index=0&id=1535d698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1535d698",
  null
  
)

export default component.exports